/** Threads that are not about an application, and so get a label of their own. */
export function isSideThread(conversation) {
  return Boolean(conversation?.is_question || conversation?.is_outreach);
}

/**
 * What a conversation is about, in one line.
 *
 * An application's thread is about its role. A question asked before applying
 * has no application, so it says so — both sides need to tell the two apart
 * once a student has asked about a listing and then applied to it. A company
 * writing first to a candidate from search has neither, so it says that.
 */
export function conversationSubject(conversation) {
  if (!conversation) return null;
  if (conversation.is_question) {
    return conversation.internship_title
      ? `Question about ${conversation.internship_title}`
      : 'Question about a listing';
  }
  if (conversation.is_outreach) {
    return conversation.your_side === 'COMPANY'
      ? 'You reached out from Find Talent'
      : 'Reached out to you about an internship';
  }
  return conversation.role_title ?? conversation.internship_title ?? null;
}
